import { withTheme, WithTheme } from '@material-ui/core';
import * as Sentry from '@sentry/react';
import React, { ErrorInfo, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationMessage } from '@/components';
import { StatusLayout } from '@/layout';

class ErrorBoundary extends React.Component<WithTheme, { hasError: boolean }> {
  constructor(props: WithTheme) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(/* error: string */): { hasError: boolean } {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    Sentry.captureException(error);
  }

  render(): ReactNode {
    return this.state.hasError ? (
      <StatusLayout status="failed" height={210}>
        <NotificationMessage title={<FormattedMessage id="common.errors.global.title" />}>
          <FormattedMessage id="common.errors.global.content" />
        </NotificationMessage>
      </StatusLayout>
    ) : (
      this.props.children
    );
  }
}

export default withTheme(ErrorBoundary);
